import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg24MentionG = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M11.998 3c5.248 0 9.502 4.253 9.502 9.5l-.003.064.003.07a3.42 3.42 0 0 1-6.007 2.235 4.22 4.22 0 1 1-.831-5.645v-.283a.783.783 0 0 1 1.554-.127l.01.127v3.692a1.854 1.854 0 1 0 3.709 0l.002-.066-.003-.067a7.936 7.936 0 0 0-15.869 0 7.934 7.934 0 0 0 7.933 7.934 7.9 7.9 0 0 0 3.945-1.047.781.781 0 1 1 .779 1.357A9.47 9.47 0 0 1 11.998 22C6.752 22 2.5 17.747 2.5 12.5S6.752 3 11.998 3m0 6.844a2.656 2.656 0 1 0 0 5.311 2.656 2.656 0 0 0 .001-5.311z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24MentionG$1 = Svg24MentionG;

export { Svg24MentionG$1 as default };
